import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'fx-import-csv',
  templateUrl: './import-csv.component.html',
  styleUrls: ['./import-csv.component.sass'],
})
export class ImportCsvComponent implements OnInit {
  @ViewChild('emailList') emailList: ElementRef<HTMLElement>;
  @Output() dataLoaded: EventEmitter<string> = new EventEmitter();
  constructor() {}

  ngOnInit(): void {}

  import(files: FileList): void {
    if (files && files.length) {
      const file = files[0];
      const reader: FileReader = new FileReader();
      reader.readAsText(file);
      reader.onload = (e: any) => {
        const csv: string = reader.result as string;
        this.dataLoaded.emit(csv.split('\r\n').join(','));
      };
    }
  }

  browseFile(): void {
    const el: HTMLElement = this.emailList.nativeElement;
    el.click();
  }
}
